var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(255,255,255,0.5);opacity:0;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(79 228)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79 126.334)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 106.666)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.8,107.766c-.8-.8-4.2-1-5.3-1.1a.367.367,0,0,0-.3.1.759.759,0,0,0-.2.4v9a.472.472,0,0,0,.5.5h3a.55.55,0,0,0,.5-.3c0-.3,1.8-5.6,2-8.2A.4.4,0,0,0,5.8,107.766Z",
    transform: "translate(0 -106.666)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.487 108.766)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M189.074,152.867c-1-.3-1.9-.7-2.7-1-1.8-.8-2.6-.4-4.2,1.2a3.272,3.272,0,0,0-1.1,2.1c0,.1,0,.1.2.2.5.2,1.2.3,1.9-.8a.52.52,0,0,1,.4-.2,1.854,1.854,0,0,0,.7-.2,4.878,4.878,0,0,1,.7-.3h.2c.1,0,.3.1.4.1.5.5,1.4,1.2,2.3,2a22.909,22.909,0,0,1,3.5,3.2h.1C190.774,157.167,189.574,153.767,189.074,152.867Z",
    transform: "translate(-181.061 -151.467)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 107.666)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M369.166,128a17.537,17.537,0,0,0-6.2,1l-.3.3a.6.6,0,0,0,.1.4,56.327,56.327,0,0,1,2.9,7.9.664.664,0,0,0,.5.4h3a.472.472,0,0,0,.5-.5v-9A.472.472,0,0,0,369.166,128Z",
    transform: "translate(-362.666 -128)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.2 109.666)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M123.834,178.467c-.4-.9-2.1-2.2-3.6-3.4-.8-.7-1.6-1.3-2.2-1.8-.1.1-.3.1-.3.2a1.884,1.884,0,0,1-.8.2,2.47,2.47,0,0,1-2.9,1,1.182,1.182,0,0,1-.9-.9c-.2-1,.7-2.4,1.4-3.1h-2a50.988,50.988,0,0,1-1.6,6,11.3,11.3,0,0,0,1.1,1.1c1.9,1.6,4.1,3.2,4.5,3.5a2.842,2.842,0,0,0,1.2.4h.3l-1.6-1.6a.495.495,0,1,1,.7-.7l2,2c.2.2.4.1.6.1.3-.1.4-.3.5-.6l-2.3-2.3a.495.495,0,1,1,.7-.7l2.5,2.5a1.07,1.07,0,0,0,.8,0c.1-.1.3-.2.4-.4l-2.8-2.8a.495.495,0,0,1,.7-.7l2.9,2.9a.661.661,0,0,0,.6-.1A.679.679,0,0,0,123.834,178.467Z",
    transform: "translate(-110.934 -170.667)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerGray);
export default __webpack_public_path__ + "static/media/customerGray.3eefb998ac7c13f89c81fb67bb3f619b.svg";
export { ForwardRef as ReactComponent };